export default __webpack_public_path__ + "static/media/loading.72f68e1f.gif";